import { Action, createReducer, on } from '@ngrx/store';

import * as OccupationActions from './occupation.actions';
import * as OccupationFeatureState from './occupation.state';
import { FavoriteOccupationsActions } from '@cpd-app/state/favorite-occupations';

const occupationReducer = createReducer(
  OccupationFeatureState.initialOccupationState,

  on(
    OccupationActions.setOccupationProfile,
    (state, { occupationProfileModel }) => {
      return { ...state, occupationProfileModel };
    }
  ),

  on(OccupationActions.removeOccupationProfile, (state) => {
    return { ...state, occupationProfileModel: null };
  }),

  on(
    OccupationActions.receivedOccupationsByDemandList,
    (state, { entities }) => {
      // `addMany` throws "entities is not iterable" on a missing list, and a
      // throwing reducer blanks the occupation page. No rows is a real state.
      return OccupationFeatureState.occupationsByDemandAdapter.addMany(
        entities ?? [],
        { ...state }
      );
    }
  ),

  on(
    OccupationActions.receivedMilitaryFriendlyOccupationsList,
    (state, { entities }) => {
      return OccupationFeatureState.occupationsByDemandAdapter.addMany(
        entities ?? [],
        { ...state }
      );
    }
  ),

  on(
    FavoriteOccupationsActions.addFavoriteOccupation,
    (state, { onetCode }) => {
      const updateModel = { id: onetCode, changes: { isFavorite: true } };

      return OccupationFeatureState.occupationsByDemandAdapter.updateOne(
        updateModel,
        { ...state }
      );
    }
  ),

  on(
    FavoriteOccupationsActions.removeFavoriteOccupation,
    (state, { onetCode }) => {
      const updateModel = { id: onetCode, changes: { isFavorite: false } };

      return OccupationFeatureState.occupationsByDemandAdapter.updateOne(
        updateModel,
        { ...state }
      );
    }
  )
);

export function reducer(
  state: OccupationFeatureState.OccupationState | undefined,
  action: Action
) {
  return occupationReducer(state, action);
}
